import { estimatedColumnWidth } from "../helpers";
import { formatCurrency } from "@/utils/helpers";

const textFormatter = (value) => String(value || "");
const amountFormatter = (value) => formatCurrency(String(value || "0"));

const column = (label, columnId, widthType, formatter = textFormatter) => ({
  label,
  value: true,
  columnId,
  width: estimatedColumnWidth(widthType),
  resizable: true,
  formatter,
});

// Same order and labels as the export (SupplierSheets.ConsolidatedAging). Buckets are days
// past due on the report date; Total is what the open invoices and credit notes owe, the
// same as on Supplier Outstanding.
export default function getSupplierAgingColumns() {
  return [
    column("Supplier Number", "supplierNumber", "number"),
    column("Supplier Name", "supplierName", "name"),
    column("Not Due", "notDue", "amount", amountFormatter),
    column("1-30 Days", "30Days", "amount", amountFormatter),
    column("31-60 Days", "60Days", "amount", amountFormatter),
    column("61-90 Days", "90Days", "amount", amountFormatter),
    column("91-120 Days", "120Days", "amount", amountFormatter),
    column("121-365 Days", "over120To365Days", "amount", amountFormatter),
    column("12-18 Months", "over12To18Months", "amount", amountFormatter),
    column("18-24 Months", "over18To24Months", "amount", amountFormatter),
    column("2-3 Years", "over2To3Years", "amount", amountFormatter),
    column("Over 3 Years", "over3YearAndAbove", "amount", amountFormatter),
    column("Total Outstanding", "total", "amount", amountFormatter),
    column("Unapplied Advances", "advancePayment", "amount", amountFormatter),
    column("Net Outstanding", "net", "amount", amountFormatter),
  ];
}
